import { useContext } from 'react';
import { MainContext } from '../../contexts/main';
import { getText } from '@educaplay/app-core/language';
import { timestampToFullDate } from '@educaplay/app-core/time';
import { renewalText, renewalValues } from '../../helpers/renewal';
import { PAYMENT_METHODS } from '../../helpers/constants';
import { BlockSummaryPayment } from './BlockSummaryPayment';
import { BlockAcceptConditions } from './BlockAcceptConditions';
import styles from './BlockRenewalNotice.module.scss';

export const BlockRenewalRetry = ({ renewal, payerMode = false }) => {

    const { mainReducer, environment } = useContext( MainContext );

    const pendingRenewal = mainReducer.state.pendingRenewal;
    const values = renewalValues(pendingRenewal, environment);
    const hasOtherPaymentMethods = (mainReducer.state.paymentMethods !== false) && (mainReducer.state.paymentMethods.length > 0);

    return  <div className="e__plns__opt__main">
                <div className={ `e__plns__cta e__plns__cta--${pendingRenewal.license}` }>
                    <div className="e__plns__vlue">
                        <div className="e__plns__vlue__ttl e__plns__vlue__ttl--hlght">
                            <div className="e__plns__vlue__ttl__txt">
                                <span className="e__plns__vlue__ttl__txt__tot">
                                    { renewalText('renewal_summary_title', { plan: values.plan, periodo: getText('periodicity_' + pendingRenewal.periodicity) }) }
                                </span>
                            </div>
                            <div className="e__plns__vlue__ttl__info">
                                <span className="e__plns__vlue__end__info__nmbr">{ values.importe }</span>
                            </div>
                        </div>
                    </div>
                    <p className="e-text e-text--sm mb-lg">
                        { renewalText('renewal_summary_period', { inicio: timestampToFullDate(pendingRenewal.dueDate), fin: timestampToFullDate(pendingRenewal.periodEnd) }) }
                    </p>
                    <BlockAcceptConditions />
                    <div className={ `e__plns__cta__btn ${styles.actions}` }>
                        <button className="e-btn e-btn--premium e-btn--lg" type="button" disabled={ renewal.status != 'idle' } onClick={ renewal.retryWithSelection }>
                            <span className="e-btn__txt">{ getText('renewal_retry_now') }</span>
                        </button>
                        { !payerMode &&
                            <button className="e-btn e-btn--link" type="button" onClick={ renewal.cancelChoosing }>
                                <span className="e-btn__txt">{ getText('renewal_cancel') }</span>
                            </button>
                        }
                    </div>
                </div>
                <div className="e__plns__opt__main__wpr">
                    <div className="e__plns__opt__main__wpr__plan">
                        <BlockSummaryPayment
                            title="renewal_choose_card_title"
                            initialScreen={ hasOtherPaymentMethods ? (payerMode ? 'collapsed' : 'saved') : 'new' }
                            newPaymentMethodTypes={ [ PAYMENT_METHODS.CARD ] }
                        />
                    </div>
                </div>
            </div>;
}
